import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import IVenue from "../interfaces/IVenue";
import { IVenueObject } from "../reducers/venue";
import { HTTPMethods } from "../services/API";

import APIExtensions from "../yoello-lib/modules/API2/APIDefs";
import { useAPIV2 } from "../yoello-lib/modules/API2/useAPIv2";
import { IReduxAppState } from "../yoello-lib/modules/redux/stores";

export enum SearchTypes {
    VENUE_NAME = "venue_name",
    VENUE_SERIAL_ID = "serial_id",
    VENUE_LONG_ID = "venue_id"
}

export function useVenueSearch(searchText: string, searchTypes: SearchTypes, isGettingAllVenues?: boolean , with_venue_nickname?:boolean) {
    const { callAPI } = useAPIV2<IVenue[]>(APIExtensions.venueMerchant, { params: { include_disabled: true, size: 10 }, onMountDisabled: true });
    const [venuesList, setVenuesList] = useState<IVenue[]>([]);
    const Venues = useSelector((state: IReduxAppState) => state.venue);
    const [isLoading, setIsLoading] = useState<boolean>(false)

    useEffect(() => {
        if (searchText && searchText.length > 0) {
            setIsLoading(true);
            let type = undefined;
            if (searchTypes === SearchTypes.VENUE_SERIAL_ID) {
                if (+searchText) {
                    type = SearchTypes.VENUE_SERIAL_ID
                } else {
                    type = SearchTypes.VENUE_LONG_ID
                }
            }
            callAPI(HTTPMethods.GET, {
                params: {
                    [type ?? searchTypes]: searchText,
                    with_venue_nickname
                }
            }).then((data) => {
                if (data.isSuccessful && data.data) {
                    setVenuesList(data.data as IVenue[])
                }
            }).finally(() => {
                setIsLoading(false)
            })
        } else {
                //loading initiall venues list
                const venues: IVenue[] = [];
                Object.values(Venues).forEach((venue) => {
                    const { venueData } = venue as IVenueObject;
                    if (venueData) {
                        //sometimes we need to display only the venues that have url
                        if(with_venue_nickname && venueData.venue_nickname){
                            venues.push(venueData as IVenue)
                        }else{
                            venues.push(venueData as IVenue)
                        } 
                    }
                })
                setVenuesList([...venues])
        }
        // eslint-disable-next-line
    }, [searchText, searchTypes, isGettingAllVenues]);


    return {
        isLoading,
        venuesList
    }
}